import { render, staticRenderFns } from "./LegendaDaAgenda.vue?vue&type=template&id=6fdef560"
import script from "./LegendaDaAgenda.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegendaDaAgenda.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports